import { useEffect } from "react";

export default function useAutoRefresh(callback, interval = 30000) {
  useEffect(() => {
    if (!callback) return;

    const id = setInterval(() => {
      callback();
    }, interval);

    return () => clearInterval(id);
  }, [callback, interval]);
}
